import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  mdSelector: {
    width: '460px'
  },
  smSelector: {
    width: '180px',
    marginLeft: '10px'
  },
  selectors: {
    position: 'relative',
    zIndex: '15',
    marginTop: '40px'
  },
  chartHeader: {
    padding: '18px',
    background: palette.gradients.white,
    display: 'flex',
    justifyContent: 'space-between'
  },
  chartContainer: {
    height: '254px'
  },
  chartContent: {
    height: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  arrow: {
    transition: "all ".concat(palette.transitions.short)
  },
  arrowIsOpen: {
    transform: 'rotate(-180deg)'
  },
  collapseTable: {
    padding: '0',
    borderBottom: '0',
    '&:first-of-type': {
      paddingLeft: '0'
    },
    '&:last-of-type': {
      paddingRight: '0'
    },
    '& .MuiTableRow-root': {
      backgroundColor: palette.shades[200],
      '& + .MuiTableRow-root': {
        borderTop: "1px solid ".concat(palette.shades[300])
      }
    }
  },
  sendReminderToAllTrigger: {
    marginLeft: '10px'
  },
  collapseIsOpen: {
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  unitCell: {
    width: '80px'
  },
  tooltipCellSm: {
    maxWidth: '300px',
    width: '300px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  addressCell: {
    maxWidth: '550px',
    width: '550px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  tableContainer: {
    boxShadow: 'none',
    border: "1px solid ".concat(palette.shades[300])
  },
  periodCell: {
    width: '130px',
    maxWidth: '130px'
  },
  totalCell: {
    width: '100px',
    maxWidth: '100px'
  },
  actionCell: {
    width: '150px',
    maxWidth: '150px'
  },
  emptyPlaceholder: {
    height: '466px',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: 'none',
    borderRadius: '0 0 2px 2px'
  },
  emptyPlaceholderSingleChart: {
    height: '254px',
    maxHeight: '254px',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    borderTop: 'none',
    borderRadius: '0 0 2px 2px'
  }
}));
export default useStyles;